import { IconComponentProps } from '../IconTypes';

const CloseSmall = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.05859 9.05859C9.30078 8.8125 9.69922 8.8125 9.94141 9.05859L12 11.1172L14.0586 9.05859C14.3008 8.8125 14.6992 8.8125 14.9414 9.05859C15.1875 9.30078 15.1875 9.69922 14.9414 9.94141L12.8828 12L14.9414 14.0586C15.1875 14.3008 15.1875 14.6992 14.9414 14.9414C14.6992 15.1875 14.3008 15.1875 14.0586 14.9414L12 12.8828L9.94141 14.9414C9.69922 15.1875 9.30078 15.1875 9.05859 14.9414C8.8125 14.6992 8.8125 14.3008 9.05859 14.0586L11.1172 12L9.05859 9.94141C8.8125 9.69922 8.8125 9.30078 9.05859 9.05859Z"
      fill="currentColor"
    />
  </svg>
);

export default CloseSmall;
